import { GameEvents, type StateChangedPayload } from "@/game/events/game-events";
import { RESOURCE_LABELS, type ResourceId } from "@/game/model/resources";

let root: HTMLElement | null = null;

export function mountDomHud(): void {
  root = document.getElementById("hud");
  if (!root) return;
  root.innerHTML = `
    <div class="hud-row" id="hud-resources"></div>
    <div class="hud-row">
      <span class="label">อัตรา Focus</span>
      <span class="value" id="hud-fps">—</span>
      <span class="label">พลังคลิก</span>
      <span class="value" id="hud-click">—</span>
    </div>
    <p class="hint" id="hud-hint"></p>
  `;

  window.addEventListener(GameEvents.StateChanged, (event) => {
    const detail = (event as CustomEvent<StateChangedPayload>).detail;
    renderState(detail.state);
  });
}

function renderState(state: StateChangedPayload["state"]): void {
  if (!root) return;
  const resourcesEl = root.querySelector("#hud-resources");
  if (resourcesEl) {
    resourcesEl.innerHTML = (["focus", "clarity", "resilience"] as ResourceId[])
      .map(
        (id) =>
          `<span><span class="label">${RESOURCE_LABELS[id]}</span> <span class="value">${formatNum(state.resources[id])}</span></span>`,
      )
      .join("");
  }
  const fps = root.querySelector("#hud-fps");
  if (fps) fps.textContent = `${state.focusPerSecond.toFixed(2)}/วิ.`;
  const click = root.querySelector("#hud-click");
  if (click) click.textContent = state.clickPower.toFixed(1);
}

export function setHudHint(text: string): void {
  const el = document.getElementById("hud-hint");
  if (el) el.textContent = text;
}

function formatNum(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 10_000) return `${(n / 1_000).toFixed(1)}K`;
  if (n >= 100) return n.toFixed(0);
  return n.toFixed(1);
}
